import React, { useEffect, useRef, useState } from 'react'
import FirstNationsArt from '../../assets/img/first-nations-artwork-icon.png'
import { SocialMediaNavigationItems } from '../megamenu/data/SecondaryNavigationItems'
import { NavigationFooter } from '../megamenu/navigation/NavigationFooter'
import FooterTools from './FooterTools'
import Conditional from './Conditional'
import MyAccountFooter from './MyAccountFooter'
import { AccountInfo } from '@azure/msal-browser'
import axios, { CancelTokenSource } from 'axios'
import { INavItemWithHeadingsItems } from '../megamenu/interfaces/Navigation.Interface.Footer'
import MegamenuContentService from '../../services/MegamenuContentService'

export interface IFooterProps {
  showFooterTools: boolean
  showMegaFooter?: boolean
  title?: string
  activeAccount: AccountInfo
}
const Footer = (props: IFooterProps) => {
  const [secondaryNavItems, setSecondaryNavItems] =
    useState<INavItemWithHeadingsItems>()
  const [primaryNavigations, setPrimaryNavigations] =
    useState<INavItemWithHeadingsItems>()
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)

  const fetchBottomFooterData = async (source: CancelTokenSource) => {
    return await MegamenuContentService.getFooterContentLinks(source).then(
      (response) => {
        // console.log(response.result[3])
        return response.result
      }
    )
  }

  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    fetchBottomFooterData(source)
      .then((footer) => {
        if (mountedRef.current) {
          setPrimaryNavigations(footer)
          setSecondaryNavItems(footer[3].items)
        }
      })
      .finally(() => {
        if (mountedRef.current) {
          setIsLoading(false)
        }
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  return (
    <>
      <div id="rap-footer">
        <p></p>
        <p className="content-wrapper">
          <img src={FirstNationsArt} alt="Traditional Custodians" />
          The Fair Work Ombudsman acknowledges the Traditional Custodians of
          Country throughout Australia and their continuing connection to land,
          waters, skies and communities. We pay our respects to them, their
          Cultures, and Elders past and present.
        </p>
        <p className="print-only">
          The Office of the Fair Work Ombudsman is committed to providing you
          with advice that you can rely on. The information contained in this
          fact sheet is general in nature. If you are unsure about how it
          applies to your situation, you can call our Infoline on 13 13 94 or
          speak with a union, industry association or workplace relations
          professional.
        </p>
      </div>
      <Conditional if={props.showFooterTools}>
        <FooterTools title={props.title} activeAccount={props.activeAccount} />
      </Conditional>
      <Conditional if={!props.showMegaFooter}>
        <MyAccountFooter />
      </Conditional>
      <Conditional if={props.showMegaFooter && !isLoading}>
        <footer className="site-links-mega">
          <NavigationFooter
            primary={primaryNavigations}
            secondary={secondaryNavItems}
            social={SocialMediaNavigationItems}
          />
        </footer>
      </Conditional>
    </>
  )
}

export default Footer
